export default function () {
  this.doStart()
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/upcoming/components/event-details/resources/mounted.js